export enum ButtonTypes {
	Default = 'default',
	BlackSolid = 'blackSolid',
	WhiteGhost = 'whiteGhost',
	BlackGhost = 'blackGhost'
}
